import AspenBenefitsSlider from './DefaultView';
export default AspenBenefitsSlider;
